var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","help-collapsed":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('Details',{attrs:{"details":_vm.salesData}}),_c('Delivery',{attrs:{"details":_vm.salesData}}),_c('Items',{attrs:{"items":_vm.salesData.Items}}),_c('Total',{attrs:{"details":_vm.salesData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }